// extracted by mini-css-extract-plugin
export default {"hideOnSmall":"NavbarAdmin_hideOnSmall_byu7V"};